import { FavoriteButton } from '@/components/FavoriteButton';
import { useMatchMediaContext } from '@/providers/MatchMediaProvider';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { useBreadcrumbs } from '../hooks/useBreadcrumbs';

export const Breadcrumbs: React.FC = () => {
  const breadcrumbs = useBreadcrumbs();
  const { t } = useTranslation();
  const { isXl } = useMatchMediaContext();
  if (!breadcrumbs.length) return null;

  return (
    <nav className="flex min-w-0 items-center px-3 lg:px-5">
      <ol
        className="xl:font-sm flex min-w-0 flex-wrap items-center gap-y-0 text-sm leading-none font-normal"
        aria-label="Breadcrumb"
      >
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const key = breadcrumb.route ?? `${breadcrumb.label}-${String(index)}`;
          const isClickable = !!(breadcrumb.isClickable && breadcrumb.route && !isLast);

          return (
            <span key={key} className="nowrap flex items-center whitespace-nowrap">
              <li
                {...(isLast ? { 'aria-current': 'page' } : {})}
                className={cn('flex h-6 items-center leading-none text-white/45', isLast && 'mr-2')}
              >
                {isClickable ? (
                  <NavLink
                    to={breadcrumb.route ?? ''}
                    className={cn('leading-none transition-colors hover:text-white/65')}
                  >
                    {t(breadcrumb.label)}
                  </NavLink>
                ) : (
                  <span className={cn('leading-none', isLast && 'text-white')}>{t(breadcrumb.label)}</span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden="true" className="mx-2 flex-shrink-0 text-white/45">
                  /
                </li>
              )}
              {isLast && (
                <FavoriteButton
                  code={breadcrumb.code}
                  itemText={breadcrumb.label}
                  className={cn('hover:bg-secondary-500 active:bg-secondary-400', isXl ? 'h-8 w-8' : 'h-6 w-6')}
                />
              )}
            </span>
          );
        })}
      </ol>
    </nav>
  );
};
